import * as Actions from './item.actions';
import { AusmitError } from "../../shared/interfaces";
import { EmptyPaginator, PaginatorModel } from "../../shared/interfaces/PaginatorModel";
import { CriteriaModel, EmptyCriteria } from "../../shared/interfaces/CriteriaModel";
import { IItem } from "../../shared/interfaces/iitem";

/*Defining the state shape*/
export interface State {
	error: AusmitError | null;
	hasError: boolean;
	requestProcessing: boolean;
	typesList: {
		requestProcessing: boolean;
		data?: any;
	};
	itemList: {
		criteria: CriteriaModel;
		requestProcessing: boolean;
		response: PaginatorModel;
	};
	item: {
		requestProcessing: boolean;
		response: IItem | null;
	};
	GetItems: {
		criteria: CriteriaModel;
		requestProcessing: boolean;
		response: PaginatorModel | null;
	};
	PostComment: {
		response: any;
	};
	LikeItem: {
		response: any;
	};
	AddToCart: {
		response: any;
	};
	CompareItems: {
		response: any
	}
	GetItemFromCart: {
		response: any;
	};
	DeleteItemFromCart: {
		response: any;
	};
	RemoveItemFromCart: {
		response: any;
	};
	CheckoutData: {
		response: any;
	};
	phItemPaymentStatus: {
		response: any
	};
	GetAllCustomJewellery: {
		criteria: CriteriaModel;
		requestProcessing: boolean;
		response: PaginatorModel | null;
	};
	CustomJewelleryCheckOutDetail: {
		response: any
	};
	CustomJewelleryPaymentStatus: {
		response: any
	};

	CheckCustomJewPaymentType: {
		response: any
	};

	GetReview: {
		requestProcessing: boolean;
		criteria: CriteriaModel;
		response: PaginatorModel;
	},
	GetAllItemsForWeb: {
		requestProcessing: boolean;
		criteria: CriteriaModel;
		response: PaginatorModel;
	},
	GetAllCompareData: {
		requestProcessing: boolean;
		criteria: CriteriaModel;
		response: PaginatorModel;
	},
	GetStoreItemsForWeb: {
		criteria: CriteriaModel;
		requestProcessing: boolean;
		response: PaginatorModel;
	};
	GetCustomJewelleryPriceDetails: {
		requestProcessing: boolean;
		response: any
	};
	CheckServiceAbility: {
		response: any
	};
	CountTotalItem: {
		response: any
	};
}

/*Setting the initial state*/
export const initialState: State = {
	error: null,
	hasError: false,
	requestProcessing: false,
	typesList: {
		requestProcessing: false,
	},
	itemList: {
		criteria: EmptyCriteria,
		requestProcessing: false,
		response: EmptyPaginator,
	},
	item: {
		requestProcessing: false,
		response: null,
	},
	GetItems: {
		criteria: EmptyCriteria,
		requestProcessing: false,
		response: null
	},
	PostComment: {
		response: null
	},
	LikeItem: {
		response: null,
	},
	AddToCart: {
		response: null,
	},
	CompareItems: {
		response: null,
	},
	GetItemFromCart: {
		response: null,
	},
	DeleteItemFromCart: {
		response: null,
	},
	RemoveItemFromCart: {
		response: null,
	},
	CheckoutData: {
		response: null
	},
	phItemPaymentStatus: {
		response: null
	},
	GetAllCustomJewellery: {
		criteria: EmptyCriteria,
		requestProcessing: false,
		response: null,
	},
	CustomJewelleryCheckOutDetail: {
		response: null
	},
	CustomJewelleryPaymentStatus: {
		response: null
	},
	CheckCustomJewPaymentType: {
		response: null
	},
	GetReview: {
		requestProcessing: false,
		criteria: EmptyCriteria,
		response: EmptyPaginator,
	},
	GetAllItemsForWeb: {
		requestProcessing: false,
		criteria: EmptyCriteria,
		response: EmptyPaginator,
	},
	GetAllCompareData: {
		requestProcessing: false,
		criteria: EmptyCriteria,
		response: EmptyPaginator,
	},
	GetStoreItemsForWeb: {
		criteria: EmptyCriteria,
		requestProcessing: false,
		response: EmptyPaginator,
	},
	GetCustomJewelleryPriceDetails: {
		requestProcessing: false,
		response: null
	},
	CheckServiceAbility: {
		response: null
	},
	CountTotalItem: {
		response: null
	},
};

/*Creating the reducer function*/
export function ItemReducer(
	state = initialState,
	action: Actions.Actions
): State {
	switch (action.type) {
		case Actions.ActionTypes.GetAllTypes: {
			return {
				...state,
				requestProcessing: true,
				typesList: {
					requestProcessing: true,
				},
			};
		}
		case Actions.ActionTypes.GetAllTypesSuccess: {
			return {
				...state,
				error: null,
				hasError: false,
				requestProcessing: false,
				typesList: {
					requestProcessing: false,
					data: action.payload
				},
			};
		}
		case Actions.ActionTypes.GetAllTypesError: {
			return {
				...state,
				requestProcessing: false,
				error: action.payload,
				hasError: true,
				typesList: {
					requestProcessing: false,
				},
			};
		}

		case Actions.ActionTypes.GetItemsByStoreId: {
			return {
				...state,
				itemList: {
					...state.itemList,
					requestProcessing: true,
					criteria: action.payload.criteria,
				},
			};
		}
		case Actions.ActionTypes.GetItemsByStoreIdSuccess: {
			return {
				...state,
				error: null,
				hasError: false,
				itemList: {
					...state.itemList,
					requestProcessing: false,
					response: action.payload,
				},
			};
		}
		case Actions.ActionTypes.GetItemsByStoreIdError: {
			return {
				...state,
				error: action.payload,
				hasError: true,
				itemList: {
					...state.itemList,
					requestProcessing: false,
				},
			};
		}

		case Actions.ActionTypes.GetItem: {
			return {
				...state,
				requestProcessing: true,
			};
		}
		case Actions.ActionTypes.GetItemSuccess: {
			return {
				...state,
				error: null,
				hasError: false,
				requestProcessing: false,
				item: {
					...state.item,
					response: action.payload
				},
			};
		}
		case Actions.ActionTypes.GetItemError: {
			return {
				...state,
				error: action.payload,
				hasError: true,
				requestProcessing: false,
				item: {
					...state.item,
					response: null
				},
			};
		}
		case Actions.ActionTypes.ClearGetItem: {
			return {
				...state,
				item: {
					response: null,
					requestProcessing: false,
				},
			};
		}

		case Actions.ActionTypes.GetItems: {
			return {
				...state,
				GetItems: {
					criteria: action.payload,
					requestProcessing: true,
					response: null
				}
			};
		}
		case Actions.ActionTypes.GetItemsSuccess: {
			return {
				...state,
				GetItems: {
					...state.GetItems,
					requestProcessing: false,
					response: action.payload
				}
			};
		}
		case Actions.ActionTypes.GetItemsError: {
			return {
				...state,
				error: action.payload,
				hasError: true,
				GetItems: {
					...state.GetItems,
					requestProcessing: false,
					response: EmptyPaginator
				}
			};
		}

		case Actions.ActionTypes.ItemPostComment: {
			return {
				...state,
				requestProcessing: true,
				PostComment: {
					response: null
				}
			};
		}
		case Actions.ActionTypes.ItemPostCommentSuccess: {
			return {
				...state,
				requestProcessing: false,
				PostComment: {
					response: action.payload
				}
			};
		}
		case Actions.ActionTypes.ItemPostCommentError: {
			return {
				...state,
				error: action.payload,
				hasError: true,
				requestProcessing: false,
				PostComment: {
					response: null
				}
			};
		}
		case Actions.ActionTypes.ItemPostCommentReset: {
			return {
				...state,
				requestProcessing: false,
				PostComment: {
					response: null
				}
			};
		}

		case Actions.ActionTypes.LikeItem: {
			return {
				...state,
				requestProcessing: true,
				LikeItem: {
					response: null
				}
			};
		}
		case Actions.ActionTypes.DisLikeItem: {
			return {
				...state,
				requestProcessing: true,
				LikeItem: {
					response: null
				}
			};
		}
		case Actions.ActionTypes.LikeItemSuccess: {
			return {
				...state,
				requestProcessing: false,
				LikeItem: {
					response: action.payload
				}
			};
		}
		case Actions.ActionTypes.LikeItemError: {
			return {
				...state,
				error: action.payload,
				hasError: true,
				requestProcessing: false,
				LikeItem: {
					response: null
				}
			};
		}
		case Actions.ActionTypes.LikeItemReset: {
			return {
				...state,
				requestProcessing: false,
				LikeItem: {
					response: null
				}
			};
		}
		case Actions.ActionTypes.CompareItems: {
			return {
				...state,
				requestProcessing: true,
				CompareItems: {
					response: null
				}
			};
		}
		case Actions.ActionTypes.CompareItemsSuccess: {
			return {
				...state,
				requestProcessing: false,
				CompareItems: {
					response: action.payload
				}
			};
		}
		case Actions.ActionTypes.CompareItemsError: {
			return {
				...state,
				error: action.payload,
				hasError: true,
				requestProcessing: false,
				CompareItems: {
					response: action.payload
				}
			};
		}
		case Actions.ActionTypes.AddToCartItem: {
			return {
				...state,
				requestProcessing: true,
				AddToCart: {
					response: null
				}
			};
		}
		case Actions.ActionTypes.AddToCartItemSuccess: {
			return {
				...state,
				requestProcessing: false,
				AddToCart: {
					response: action.payload
				}
			};
		}
		case Actions.ActionTypes.AddToCartItemError: {
			return {
				...state,
				error: action.payload,
				hasError: true,
				requestProcessing: false,
				AddToCart: {
					response: action.payload
				}
			};
		}
		case Actions.ActionTypes.GetItemFromCart: {
			return {
				...state,
				requestProcessing: true,
				GetItemFromCart: {
					response: null
				}
			};
		}
		case Actions.ActionTypes.GetItemFromCartSuccess: {
			return {
				...state,
				requestProcessing: false,
				GetItemFromCart: {
					response: action.payload
				}
			};
		}
		case Actions.ActionTypes.GetItemFromCartError: {
			return {
				...state,
				error: action.payload,
				hasError: true,
				requestProcessing: false,
				GetItemFromCart: {
					response: null
				}
			};
		}
		case Actions.ActionTypes.DeleteItemFromCart: {
			return {
				...state,
				requestProcessing: true,
				DeleteItemFromCart: {
					response: null
				}
			};
		}
		case Actions.ActionTypes.DeleteItemFromCartSuccess: {
			return {
				...state,
				requestProcessing: false,
				DeleteItemFromCart: {
					response: action.payload
				}
			};
		}
		case Actions.ActionTypes.DeleteItemFromCartError: {
			return {
				...state,
				error: action.payload,
				hasError: true,
				requestProcessing: false,
				DeleteItemFromCart: {
					response: null
				}
			};
		}
		case Actions.ActionTypes.RemoveItemFromCart: {
			return {
				...state,
				requestProcessing: true,
				RemoveItemFromCart: {
					response: null
				}
			};
		}
		case Actions.ActionTypes.RemoveItemFromCartSuccess: {
			return {
				...state,
				requestProcessing: false,
				RemoveItemFromCart: {
					response: action.payload
				}
			};
		}
		case Actions.ActionTypes.RemoveItemFromCartError: {
			return {
				...state,
				error: action.payload,
				hasError: true,
				requestProcessing: false,
				RemoveItemFromCart: {
					response: null
				}
			};
		}
		case Actions.ActionTypes.GetCheckoutData: {
			return {
				...state,
				requestProcessing: true,
				CheckoutData: {
					response: null
				}
			};
		}
		case Actions.ActionTypes.GetCheckoutDataSuccess: {
			return {
				...state,
				requestProcessing: false,
				CheckoutData: {
					response: action.payload
				}
			};
		}
		case Actions.ActionTypes.GetCheckoutDataError: {
			return {
				...state,
				error: action.payload,
				hasError: true,
				requestProcessing: false,
				CheckoutData: {
					response: null
				}
			};
		}

		case Actions.ActionTypes.phItemPaymentStatus: {
			return {
				...state,
				requestProcessing: true,
				phItemPaymentStatus: {
					response: null
				}
			};
		}
		case Actions.ActionTypes.phItemPaymentStatusSuccess: {
			return {
				...state,
				requestProcessing: false,
				phItemPaymentStatus: {
					response: action.payload
				}
			};
		}
		case Actions.ActionTypes.phItemPaymentStatusError: {
			return {
				...state,
				error: action.payload,
				hasError: true,
				requestProcessing: false,
				phItemPaymentStatus: {
					response: null
				}
			};
		}

		case Actions.ActionTypes.GetAllCustomJewellery: {
			return {
				...state,
				requestProcessing: true,
				GetAllCustomJewellery: {
					// ...state.GetAllCustomJewellery,
					criteria: action.payload,
					requestProcessing: true,
					response: null
				},
			};
		}
		case Actions.ActionTypes.GetAllCustomJewellerySuccess: {
			return {
				...state,
				error: null,
				hasError: false,
				requestProcessing: false,
				GetAllCustomJewellery: {
					...state.GetAllCustomJewellery,
					requestProcessing: false,
					response: action.payload,
				},
			};
		}

		case Actions.ActionTypes.GetAllCustomJewelleryError: {
			return {
				...state,
				error: action.payload,
				hasError: true,
				requestProcessing: false,
				GetAllCustomJewellery: {
					...state.GetAllCustomJewellery,
					requestProcessing: false,
					response: EmptyPaginator
				},
			}
		}

		case Actions.ActionTypes.GetReview: {
			return {
				...state,
				GetReview: {
					...state.GetReview,
					requestProcessing: true,
					criteria: action.payload,
				},
			}
		}
		case Actions.ActionTypes.GetReviewSuccess: {
			return {
				...state,
				GetReview: {
					...state.GetReview,
					requestProcessing: false,
					response: action.payload,
				},
			};
		}

		case Actions.ActionTypes.GetReviewError: {
			return {
				...state,
				error: action.payload,
				hasError: true,
				GetReview: {
					...state.GetReview,
					requestProcessing: false,
				},
			};
		}

		case Actions.ActionTypes.CustomJewelleryCheckOutDetail: {
			return {
				...state,
				requestProcessing: true,
				CustomJewelleryCheckOutDetail: {
					response: null
				}
			};
		}
		case Actions.ActionTypes.CustomJewelleryCheckOutDetailSuccess: {
			return {
				...state,
				requestProcessing: false,
				CustomJewelleryCheckOutDetail: {
					response: action.payload
				}
			};
		}
		case Actions.ActionTypes.CustomJewelleryCheckOutDetailError: {
			return {
				...state,
				error: action.payload,
				hasError: true,

			}
		}

		case Actions.ActionTypes.GetAllItemsForWeb: {
			return {
				...state,
				requestProcessing: true,
				GetAllItemsForWeb: {
					...state.GetAllItemsForWeb,
					requestProcessing: true,
					criteria: action.payload,
				},
			};
		}
		case Actions.ActionTypes.GetAllItemsForWebSuccess: {
			return {
				...state,
				requestProcessing: false,
				GetAllItemsForWeb: {
					...state.GetAllItemsForWeb,
					requestProcessing: false,
					response: action.payload,
				},
			};
		}
		case Actions.ActionTypes.GetAllItemsForWebError: {
			return {
				...state,
				error: action.payload,
				hasError: true,
				requestProcessing: false,
				GetAllItemsForWeb: {
					...state.GetAllItemsForWeb,
					requestProcessing: false,
				},
			};
		}

		case Actions.ActionTypes.GetStoreItemsForWeb: {
			return {
				...state,
				requestProcessing: true,
				itemList: {
					...state.itemList,
					requestProcessing: true,
					criteria: action.payload.criteria,
				},
			};
		}
		case Actions.ActionTypes.GetStoreItemsForWebSuccess: {
			return {
				...state,
				error: null,
				hasError: false,
				requestProcessing: false,
				itemList: {
					...state.itemList,
					requestProcessing: false,
					response: action.payload,
				},
			};
		}
		case Actions.ActionTypes.GetStoreItemsForWebError: {
			return {
				...state,
				error: action.payload,
				hasError: true,
				requestProcessing: false,
				itemList: {
					...state.itemList,
					requestProcessing: false,
				},
			};
		}



		case Actions.ActionTypes.CustomJewelleryPaymentStatus: {
			return {
				...state,
				requestProcessing: true,
				CustomJewelleryPaymentStatus: {
					response: null
				}
			};
		}
		case Actions.ActionTypes.CustomJewelleryPaymentStatusSuccess: {
			return {
				...state,
				requestProcessing: false,
				CustomJewelleryPaymentStatus: {
					response: action.payload
				}
			};
		}
		case Actions.ActionTypes.CustomJewelleryPaymentStatusError: {
			return {
				...state,
				error: action.payload,
				hasError: true,
				requestProcessing: false,
				CustomJewelleryPaymentStatus: {
					response: null
				}
			};
		}

		case Actions.ActionTypes.CheckCustomJewPaymentType: {
			return {
				...state,
				requestProcessing: true,
				CheckCustomJewPaymentType: {
					response: null
				}
			};
		}
		case Actions.ActionTypes.CheckCustomJewPaymentTypeSuccess: {
			return {
				...state,
				requestProcessing: false,
				CheckCustomJewPaymentType: {
					response: action.payload
				}
			};
		}
		case Actions.ActionTypes.CheckCustomJewPaymentTypeError: {
			return {
				...state,
				error: action.payload,
				hasError: true,
				requestProcessing: false,
				CheckCustomJewPaymentType: {
					response: null
				}
			};
		}

		case Actions.ActionTypes.GetCustomJewelleryPriceDetails: {
			return {
				...state,
				requestProcessing: true,
				GetCustomJewelleryPriceDetails: {
					requestProcessing: true,
					response: null
				}
			};
		}
		case Actions.ActionTypes.GetCustomJewelleryPriceDetailsSuccess: {
			return {
				...state,
				requestProcessing: false,
				GetCustomJewelleryPriceDetails: {
					requestProcessing: false,
					response: action.payload
				}
			};
		}
		case Actions.ActionTypes.GetCustomJewelleryPriceDetailsError: {
			return {
				...state,
				error: action.payload,
				hasError: true,
				requestProcessing: false,
				GetCustomJewelleryPriceDetails: {
					requestProcessing: false,
					response: null
				}
			};
		}

		case Actions.ActionTypes.GetAllCompareData: {
			return {
				...state,
				GetAllCompareData: {
					...state.GetAllCompareData,
					requestProcessing: true,
					criteria: action.payload,
				},
			};
		}
		case Actions.ActionTypes.GetAllCompareDataSuccess: {
			return {
				...state,
				GetAllCompareData: {
					...state.GetAllCompareData,
					requestProcessing: false,
					response: action.payload,
				},
			};
		}
		case Actions.ActionTypes.GetAllCompareDataError: {
			return {
				...state,
				error: action.payload,
				hasError: true,
				requestProcessing: false,
				GetAllCompareData: {
					...state.GetAllCompareData,
					requestProcessing: false,
				},
			};
		}

		case Actions.ActionTypes.CheckServiceAbility: {
			return {
				...state,
				requestProcessing: true,
				CheckServiceAbility: {
					response: null
				}
			};
		}
		case Actions.ActionTypes.CheckServiceAbilitySuccess: {
			return {
				...state,
				requestProcessing: false,
				CheckServiceAbility: {
					response: action.payload
				}
			};
		}
		case Actions.ActionTypes.CheckServiceAbilityError: {
			return {
				...state,
				error: action.payload,
				requestProcessing: false,
				hasError: true,
			}
		}

		case Actions.ActionTypes.CountTotalItem: {
			return {
				...state,
				requestProcessing: true,
				CountTotalItem: {
					response: null
				}
			};
		}
		case Actions.ActionTypes.CountTotalItemSuccess: {
			return {
				...state,
				requestProcessing: false,
				CountTotalItem: {
					response: action.payload
				}
			};
		}
		case Actions.ActionTypes.CountTotalItemError: {
			return {
				...state,
				error: action.payload,
				requestProcessing: false,
				hasError: true,
			}
		}

		default:
			return state;
	}
}
